/* eslint-disable */
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  changeIndex: ['index'],
  setCameraLockout: ['cameraLockout'],
  sendDragRightOnCam: ['dragRightOnCam'],
  sendTouchUpToCam: ['touchUpToCam'],
  setForceRefreshIndex: ['forceRefreshIndex']
})

export const SwiperTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  indexChange: 1,
  image : null,
  fromScreen : null,
  dragRightOnCam : 0, // if 1, user has dragged right while on the camera, should trigger an operation in camera
  touchUpToCam : 0,
  ktagCallerInfo : false,
  recentBarcoderOutput : false, // when using bar/QR code reader to scan before making a post
  cameraLockout: false,
  music: {
    muted: false,
		songDetails: null,
	},
	preloadMusic: {
		songDetails: null,
	},
  forceRefreshIndex: 0
})

/* ------------- Selectors ------------- */

export const SwiperSelectors = {
  getData: state => state.data
}

/* ------------- Reducers ------------- */

// request the data from an api
export const changeIndex = (state, action) => {

  // pass in barcoderOutput : 'clear' to wipe out prior barcoder result

  //console.log('changeIndex reducer action keys = ', Object.keys(action))
  const { index: { indexChange = state.indexChange, music = false, preloadMusic = false, ktagCallerInfo = false, image = null , fromScreen = false, barcoderOutput = false} } = action

  //console.log("ready to store to redux barcoderOutput = " + barcoderOutput)

  // note: strings are true
  //console.log('swiper redux ktagCallerInfo: ' + (ktagCallerInfo?JSON.stringify(ktagCallerInfo):'false'))

  let toStore = { indexChange : indexChange , image : image , fromScreen : fromScreen , ktagCallerInfo : ktagCallerInfo? JSON.stringify(ktagCallerInfo): false}
  if (music !== false)
    toStore.music = music
	if (preloadMusic !== false)
		toStore.preloadMusic = preloadMusic
  if (indexChange == 0)
    if (toStore.music)
      toStore.music.muted = true
    else
      toStore.music = Object.assign({}, state.music, {muted: true})

  // only set this if we are clearing barcode output
  if (barcoderOutput === 'clear') toStore = {recentBarcoderOutput : false}
  else if (barcoderOutput) toStore.recentBarcoderOutput = barcoderOutput // only store if not falsy so we don't accidentally clear this

  //console.log("in changeIndex swiper redux, indexChange = " + indexChange + " previous state.indexChange = " + state.indexChange)

  return state.merge(toStore)
}

export const setCameraLockout = (state, action) => {
  const { cameraLockout } = action
  console.log(`in setCameraLockout swiper redux, cameraLockout: ${cameraLockout} previous state.cameraLockout: ${state.cameraLockout}`)
  return state.merge({cameraLockout})
}

export const setForceRefreshIndex = (state, action) => {
  const { forceRefreshIndex } = action
  return state.merge({forceRefreshIndex})
}

export const sendDragRightOnCam = (state, action) => {
  //console.log("in sendDragRightOnCam action.dragRightOnCam = " + JSON.stringify(action.dragRightOnCam))
  const dragRightOnCam = action.dragRightOnCam.dragRightOnCam // too many layers
  return state.merge({ dragRightOnCam : dragRightOnCam })
}

export const sendTouchUpToCam = (state, action) => {
  //console.log("in sendTouchUpToCam action.touchUpToCam = " + JSON.stringify(action.touchUpToCam))
  const touchUpToCam = action.touchUpToCam.touchUpToCam // too many layers
  return state.merge({ touchUpToCam : touchUpToCam })
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.CHANGE_INDEX]: changeIndex,
  [Types.SET_CAMERA_LOCKOUT]: setCameraLockout,
  [Types.SEND_DRAG_RIGHT_ON_CAM]: sendDragRightOnCam,
  [Types.SEND_TOUCH_UP_TO_CAM]: sendTouchUpToCam,
  [Types.SET_FORCE_REFRESH_INDEX]: setForceRefreshIndex
})
